import React from 'react';
import Drawer from '@mui/material/Drawer';
import Slide from '@mui/material/Slide';
import CloseButton from '@/components/common/CloseButton';
import translate from '@/lib/intl/translate';
import { useQueryProvider } from '@/modules/QueryProvider';
import type ConstituentSearchFilterParams from '../types/ConstituentSearchFilterParams';
// eslint-disable-next-line import/no-cycle -- TODO: Fix this the next time the file is edited.
import ConstituentSearchAdvancedFilter from './ConstituentSearchAdvancedFilter';
import ConstituentSearchFilter from './ConstituentSearchFilter';

function ConstituentSearchDrawer({
  enableSavedFilters = false,
  onClose,
  open,
}: {
  enableSavedFilters?: boolean;
  onClose: () => void;
  open: boolean;
}) {
  const { query } = useQueryProvider<ConstituentSearchFilterParams>();
  const { advancedFilters } = query;
  const [showAdvancedFilters, setShowAdvancedFilters] = React.useState(
    !!advancedFilters?.length,
  );

  const toggleAdvancedFilters = () => {
    setShowAdvancedFilters(!showAdvancedFilters);
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        className:
          'max-w-xl type-body1 w-full max-h-screen overflow-y-auto flex flex-col',
      }}
    >
      <div className="shrink-0 grow-0 border-b border-grey-300 px-6 pt-4 pb-4">
        <CloseButton onClick={onClose} className="absolute right-3 top-3" />
        <h2 className="grow type-h2">{translate('FILTERS')}</h2>
      </div>
      <div className="relative flex shrink grow flex-col">
        <Slide
          direction="right"
          in={!showAdvancedFilters}
          mountOnEnter
          unmountOnExit
          appear={false}
        >
          <ConstituentSearchFilter
            enableSavedFilters={enableSavedFilters}
            onClose={onClose}
            toggleAdvancedFilters={toggleAdvancedFilters}
          />
        </Slide>
        <Slide
          direction="left"
          in={showAdvancedFilters}
          mountOnEnter
          unmountOnExit
          appear={false}
        >
          <ConstituentSearchAdvancedFilter
            toggleAdvancedFilters={toggleAdvancedFilters}
            onClose={onClose}
          />
        </Slide>
      </div>
    </Drawer>
  );
}

export default ConstituentSearchDrawer;
